module.exports = __webpack_public_path__ + "static/media/banner-1.b4d9a9c3.png";